import type { PersonalityOption, CheckInOption } from './unifiedTypes';

export const PERSONALITY_OPTIONS: PersonalityOption[] = [
  {
    id: 'drill-sergeant',
    name: 'Drill Sergeant',
    description: 'Direct, no-nonsense accountability',
    imageFile: '/avatars/drill-sergeant.jpg',
    audioFile: '/avatars/avatar_drill_sergeant.mp3'
  },
  {
    id: 'fitness-coach',
    name: 'Fitness Coach',
    description: 'Energetic and motivational',
    imageFile: '/avatars/fitness-coach.jpg',
    audioFile: '/avatars/avatar_fitness_coach.mp3'
  },
  {
    id: 'best-friend',
    name: 'Best Friend',
    description: 'Supportive and understanding',
    imageFile: '/avatars/best-friend.jpg',
    audioFile: '/avatars/avatar_best_friend.mp3'
  },
  {
    id: 'mindful-guide',
    name: 'Mindful Guide',
    description: 'Gentle, mindfulness-focused',
    imageFile: '/avatars/mindful-guide.jpg',
    audioFile: '/avatars/avatar_mindful_guide.mp3'
  },
  {
    id: 'teacher',
    name: 'Teacher',
    description: 'Educational and encouraging',
    imageFile: '/avatars/teacher.jpg',
    audioFile: '/avatars/avatar_teacher.mp3'
  },
  {
    id: 'wise-mentor',
    name: 'Wise Mentor',
    description: 'Thoughtful and strategic',
    imageFile: '/avatars/wise-mentor.jpg',
    audioFile: '/avatars/avatar_wise_mentor.mp3'
  }
];

export const SUBSCRIPTION_OPTIONS = [
  {
    id: 'monthly_trial' as const,
    name: 'Monthly (free trial)',
    price: '$0',
    period: 'per month',
    priceId: 'price_1RgoSXBSRvPwEFDnLoBci8rF'
  },
  {
    id: 'monthly' as const,
    name: 'Monthly',
    price: '$3',
    period: 'per month',
    priceId: 'price_1ReuhCBSRvPwEFDn4cItGk2t'
  },
  {
    id: 'yearly' as const,
    name: 'Yearly',
    price: '$30',
    period: 'per year',
    savings: 'Save $6',
    priceId: 'price_1ReuhxBSRvPwEFDnwCNX1ajr'
  }
];

export const TIMEZONES = [
  'America/New_York (EST)',
  'America/Chicago (CST)',
  'America/Denver (MST)',
  'America/Los_Angeles (PST)',
  'Europe/London (GMT)',
  'Europe/Paris (CET)',
  'Europe/Berlin (CET)',
  'Asia/Tokyo (JST)',
  'Asia/Shanghai (CST)',
  'Asia/Kolkata (IST)',
  'Australia/Sydney (AEDT)',
];

export const COUNTRY_CODES = [
  { code: '+1', country: 'US/CA', flag: '🇺🇸' },
  { code: '+44', country: 'UK', flag: '🇬🇧' },
  { code: '+49', country: 'DE', flag: '🇩🇪' },
  { code: '+33', country: 'FR', flag: '🇫🇷' },
  { code: '+39', country: 'IT', flag: '🇮🇹' },
  { code: '+34', country: 'ES', flag: '🇪🇸' },
  { code: '+61', country: 'AU', flag: '🇦🇺' },
  { code: '+81', country: 'JP', flag: '🇯🇵' },
  { code: '+86', country: 'CN', flag: '🇨🇳' },
  { code: '+91', country: 'IN', flag: '🇮🇳' },
];
